import { profile } from 'api';

interface ISsoLoginData {
  isAuthenticated: boolean;
  sessionToken: string;
}

interface ISsoLoginResponse {
  succeeded: boolean;
  data: ISsoLoginData;
  errors: string[];
}

const parsedSsoLoginData = ({ isAuthenticated, sessionToken }: ISsoLoginData) => ({
  isAuthenticated,
  sessionToken,
});

export const handleLoginSso = async (username: string, password: string, companyId: string) => {
  const user = {
    username,
    password,
    companyId,
  };

  const response = await profile.post<ISsoLoginResponse>('/userlogin/login', { ...user });

  if (!response.data.succeeded || !response.data.data.isAuthenticated) {
    throw new Error('Authentication failed');
  }

  return parsedSsoLoginData(response.data.data);
};
